import React, { Suspense, lazy } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Auth from '../../../../Layout/Auth';
import POSLayout from '../../../../Layout/POSLayout';

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components
const KitchenDisplayList = lazy(() => import('../Pages/KitchenDisplayList'));
const KitchenDisplayView = lazy(() => import('../Pages/KitchenDisplayView'));
const WaiterDisplayList = lazy(() => import('../Pages/WaiterDisplayList'));
const WaiterDisplayView = lazy(() => import('../Pages/WaiterDisplayView'));

// Loading component for Suspense fallback
const Loading = () => (
  <LoadingOverlay
    active={false}
    spinner={<FadeLoader color={"#36D7B7"} />}
    text="Loading..."
    styles={{
      overlay: (base) => ({
        ...base,
        background: "rgba(255, 255, 255, 0.8)",
      }),
      content: (base) => ({
        ...base,
        color: "#36D7B7",
      }),
    }}
  >
    <div style={{ height: "100vh" }}></div>
  </LoadingOverlay>
);

function RestaurantRoute() {
  const history = useHistory();

  return (
    <Switch>

      {/* kitchen */}
      <Route
        exact
        path="/:lng/restaurant/kitchen-display/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <KitchenDisplayView history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/restaurant/kitchen-display"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <KitchenDisplayList history={history} />
            </Suspense>
          </Auth>
        )}
      />

      {/* waiters */}
      <Route
        exact
        path="/:lng/restaurant/waiter-display/:waiterId"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <WaiterDisplayView history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/restaurant/waiter-display"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <WaiterDisplayList history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
}

export default withNamespaces()(RestaurantRoute);
